export default () => [{
  id: 1,
  route: '/valledetenza',
  location: 'valledetenza',
  name: 'pressure',
  type: 'lt',
  value: 110,
  nextUpdate: Date.now()
}, {
  id: 2,
  route: '/valledetenza',
  location: 'valledetenza',
  name: 'cfpressure',
  type: 'lt',
  value: 110,
  nextUpdate: Date.now()
}, {
  id: 3,
  route: '/valledetenza',
  location: 'valledetenza',
  name: 'pressure',
  type: 'gt',
  value: 160,
  nextUpdate: Date.now()
}, {
  id: 4,
  route: '/valledetenza',
  location: 'valledetenza',
  name: 'cfpressure',
  type: 'gt',
  value: 160,
  nextUpdate: Date.now()
}, {
  id: 5,
  route: '/valledetenza',
  location: 'valledetenza',
  name: 'cfflow',
  type: 'gt',
  value: 12,
  nextUpdate: Date.now()
}, {
  id: 6,
  route: '/mochileros',
  location: 'mochileros',
  name: 'pressure',
  type: 'lt',
  value: 370,
  nextUpdate: Date.now()
}, {
  id: 7,
  route: '/mochileros',
  location: 'mochileros',
  name: 'cfpressure',
  type: 'lt',
  value: 700,
  nextUpdate: Date.now()
}, {
  id: 8,
  route: '/mochileros',
  location: 'mochileros',
  name: 'pressure',
  type: 'gt',
  value: 400,
  nextUpdate: Date.now()
}, {
  id: 9,
  route: '/mochileros',
  location: 'mochileros',
  name: 'cfpressure',
  type: 'gt',
  value: 1000,
  nextUpdate: Date.now()
}, {
  id: 10,
  route: '/mochileros',
  location: 'mochileros',
  name: 'cfflow',
  type: 'gt',
  value: 100,
  nextUpdate: Date.now()
}]



// WEBPACK FOOTER //
// ./src/store/rules.js